import React from "react";
import { claimVideoUrl, fmtBytes } from "@/lib/uploadClaimVideo";

/** 🎥 Videos attached to a claim — plays right here (streamed from the CRM, works from China too). */
export function ClaimVideos({ videos = [], ids = [], testid = "claim-videos", compact = false }) {
  const list = videos.length ? videos : ids.map((id) => ({ id }));
  if (!list.length) return null;
  return (
    <div className={`flex flex-wrap gap-3 ${compact ? "mt-1" : "mt-2"}`} data-testid={testid}>
      {list.map((v) => (
        <figure key={v.id} className="rounded-md border border-slate-300 bg-black overflow-hidden" data-testid={`${testid}-${v.id}`}>
          <video controls preload="metadata" playsInline src={claimVideoUrl(v.id)} className={compact ? "h-40 max-w-[320px]" : "h-56 max-w-[420px]"} />
          <figcaption className="px-2 py-1 text-[11px] text-slate-200 bg-slate-900 flex justify-between gap-2">
            <span className="truncate">🎥 {v.name || "video"}</span>
            {v.size ? <span className="shrink-0">{fmtBytes(v.size)}</span> : null}
          </figcaption>
        </figure>
      ))}
    </div>
  );
}
